import { AfterViewInit, ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { EnvironmentService } from '../../services/environment/environment.service';
import { googleAnalytics } from '../../../../assets/google-analytics/ga';
import { DOCUMENT } from '@angular/common';
import { BrowserWindowRef } from '../../services/window/window.service';

@Component({
  selector: 'gtd-analytics',
  template: '',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [EnvironmentService],
})
export class AnalyticsComponent implements AfterViewInit {
  constructor(
    private envService: EnvironmentService,
    @Inject(DOCUMENT) private document: Document,
    @Inject(BrowserWindowRef) private window: BrowserWindowRef
  ) {}

  public ngAfterViewInit() {
    const vars = this.envService.getVars();
    if (vars.googleAnalyticsId) {
      googleAnalytics(vars.googleAnalyticsId);
    }
    if (vars.amplitudeId) {
      this.initAmplitudeScript(vars.amplitudeId);
    }
  }

  private initAmplitudeScript(token: string) {
    const script = this.document.createElement('script');
    script.type = 'application/javascript';
    script.src = './assets/amplitude/amplitude.js';
    script.onload = () => {
      if (this.window.nativeWindow['amplitude']) {
        this.window.nativeWindow['amplitude'].init(token, { defaultTracking: true });
      }
    };
    this.document.body.appendChild(script);
  }
}
